<template>
 <div class="mr-top-40">
 <br/>
 <br/>
 <div class="container-fluid padding-bottom-3x mb-1">
      <!--content-->
      <div class="row">
        <!-- Content-->
        <div class="col-xl-10 col-lg-9 col-md-8 order-md-2">
          <!-- Search-->
           <div class="d-flex flex-wrap-reverse flex-md-nowrap justify-content-center justify-content-sm-between align-items-center mb-30">
            <div class="pt-3 pb-1 pb-sm-3 text-sm text-center text-sm-left"><span class="text-muted mr-2">Affichage des produits</span>1- {{pageSize}} Produits</div>
            <form class="input-group shop-search-box" method="get"><span class="input-group-btn">
                <button type="submit"><i class="material-icons search"></i></button></span>
               <input @keyup="search" class="form-control" type="search" style="border:2px solid #000000"
              placeholder="Recherche par Référence" v-model="filter" :disabled="brands.length>0">
            </form>
          </div>
          <!-- Products Grid there was row as default class-->
            <div class="d-flex flex-wrap justify-content-center mb-2" >
            <!-- Item-->
            <div v-for="product in filterProduct" :key="product.id"
            class="col-xl-3 col-lg-4 col-sm-6">
              <div class="product-card mb-30">
                <div class="product-card-thumb">
                  <router-link class="product-card-link" to="/product" @click.native="ProductDetail(product)">
                   </router-link><img :src="product.img"   alt="Product">
                  <div class="product-card-buttons">
                    <button class="btn btn-primary btn-sm" @click="addToCart(product)">Ajouter au panier</button>
                  </div>
                </div>
                <div class="product-card-details">
                  <h3 class="product-card-title"><b href="shop-single.html"><strong>{{product.id}} /stock:=> {{product.quantite}}</strong></b></h3>
                  <h4 class="product-card-price"><strong>{{product.price}} DA </strong></h4>


                </div>
              </div>
            </div>

          </div>


         <!-- Pagination-->
          <!--<nav class="pagination">
            <div class="column">
              <ul class="pages">
                <li class="active"><a href="#">1</a></li>
                <li><a href="#">2</a></li>
                <li><a href="#">3</a></li>
                <li><a href="#">4</a></li>
                <li>...</li>
                <li><a href="#">12</a></li>
              </ul>
            </div>
            <div class="column text-right hidden-xs-down"><a class="btn btn-outline-secondary btn-sm" href="#">Next&nbsp;<i class="material-icons keyboard_arrow_right"></i></a></div>
          </nav>
          -->
       <pagination
       :total="total"
       :page-size="pageSize"
       :callback="pageChanged"
       :options="paginationOptions" nav-class="pagination" ul-class="column pages"
       li-class="pt-2">
       </pagination>
      </div>
        <!-- Sidebar -->
        <div class="col-xl-2 col-lg-3 col-md-4 order-md-1">
          <div @click="sidebarOpen=!sidebarOpen" class="sidebar-toggle position-left"
          :class='{sidebaropen:sidebarOpen}'>
            <i class="material-icons filter_list"></i>
          </div>
          <aside class="sidebar sidebar-offcanvas position-left" :class="{offcanvasopen:sidebarOpen}">
            <span @click="sidebarOpen=!sidebarOpen" class="sidebar-close">
              <i class="material-icons icon_close"></i>
            </span>
            <!-- Widget Sorting-->
            <section class="widget widget-icon-list">
              <h3 class="widget-title"><strong>  Filter par </strong></h3>
              <ul>
                <li><a @click="ordreby('quantite')" href="#"><i class="material-icons favorite_border"></i>Popularité</a></li>
                <li><a @click="ordreby('annee')"  href="#"><i class="material-icons vertical_align_top" ></i>Dernière collection</a></li>
              </ul>
            </section>
            <!-- Widget Price Range-->
            <section class="widget widget-categories">

              <h3 class="widget-title">PRIX</h3>
              <el-slider
                    v-model="priceValue"
                    range
                    :step="10000"
                    show-stops
                    :max="80000">
              </el-slider>
              <form @submit.prevent="submit" class="price-range-slider">
                <!--<div class="ui-range-slider"></div>-->
                <div class="ui-range-slider-footer">
                  <div class="column">
                    <button class="btn btn-outline-primary btn-sm" type="submit" >Filter</button>
                  </div>
                  <div class="column">
                    <span><strong>{{priceValue[0]}}DA-{{priceValue[1]}}DA </strong></span>
                    <!--<div class="ui-range-values">
                      <div class="ui-range-value-min">${{priceValue[0]}}
                        <input type="hidden">
                      </div>&nbsp;-&nbsp;
                      <div class="ui-range-value-max">${{priceValue[1]}}
                        <input type="hidden">
                      </div>
                    </div>
                    -->
                  </div>
                </div>
              </form>
            </section>
                <!-- Widget Brand Filter-->
                <section class="widget">
               <h3 class="widget-title"><strong>Homme /</strong>  <strong> FEMME </strong> </h3>
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" @change="brandChecked" id="Homme" value="H" v-model="brands">
                <label class="custom-control-label" for="Homme"><strong>HOMME </strong>&nbsp;<span class="text-muted">(25)</span></label>
              </div>
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" @change="brandChecked" id="femme" value="F" v-model="brands">
              <label class="custom-control-label" for="femme"><strong>FEMME </strong>&nbsp;<span class="text-muted">(25)</span></label>
              </div>
            </section>
          </aside>
        </div>
      </div>
 </div>
 </div>
</template>

<script>
import pagination from 'vue-pagination-bootstrap';
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
// you probably need to import built-in style
import 'vue-range-slider/dist/vue-range-slider.css';
export default {
  components: {
    pagination
  },
  data() {
    return {
      sidebarOpen: false,
     priceValue: [15000, 85000],
      sliderValue: 50,
      filter: '',
      currentPage: 1,
      brands: [],
      pageSize: 24,
      paginationOptions: {
        offset: 4,
        previousText: 'Prev',
        previousText: 'Préc',
        nextText: 'Suivant',
      }
    };
  },
  computed: {
    ...mapGetters({

      products: 'productsfossil',
      total: 'totalProductfossil'
    }),
    //products(){
    //  if (this.$store.state.lastEntriesfossil.length > 0)
     // return this.$store.state.productsfossil
     // else
    //  return this.$store.state.allProducts

   // },
    filterProduct() {
       let filter = new RegExp(this.filter, 'i');
       if (this.brands.length > 0)
       {
return this.products.filter(el => el.name.match(filter));
       }

       else
      return this.products.filter(el => el.id.match(filter));
    }
  },
  created() {
    this.$store.dispatch('fetchDatafossil', { page: 1, filter: '', gender: '' });
  },
  methods: {
   // pageChanged(page) {
     // this.currentPage = page;
      //if (this.brands.length > 0 ) {
      //  this.$store.dispatch('fetchDatafossil', { page: page, filter: filter, gender:this.brands });
      //} else {
      //   let filter = `price:${this.priceValue}`;
     //  this.$store.dispatch('fetchDatafossil', { page: page, filter: this.filter, gender: '' });
     // }
    //},



 pageChanged(page) {

      this.currentPage = page;
      if (this.brands.length > 0 ) {
         let filter = `price:${this.priceValue}`;
        this.$store.dispatch('fetchDatafossil', { page: page, filter: filter, gender:this.brands });
      } else {
         let filter = `price:${this.priceValue}`;
        this.$store.dispatch('fetchDatafossil', { page: page, filter: this.filter, gender: '' });
      }
    },
    ordreby (filter){
      let filter2 = `ordre:${filter}`;
      console.log(filter);
      this.$store.dispatch('fetchDatafossil', { page: this.currentPage, filter: filter2, gender: '' });

    },
    submit() {
      let filter = `price:${this.priceValue}`;
      console.log(filter);
      if (this.brands.length>0)
      {
this.$store.dispatch('fetchDatafossil', { page: this.currentPage, filter: filter, gender: this.brands });
      }
      else
      {

        this.$store.dispatch('fetchDatafossil', { page: this.currentPage, filter: filter, gender: '' });
      }


    },
    search: function(event) {
      let debounce = _.debounce(() => {
        if (this.brands.length === 0)
          this.$store.dispatch('fetchDatafossil', {
            page: this.currentPage,
            filter: event.target.value,
            gender: ''
          });
      }, 500);
      debounce();
    },
    brandChecked: function(event) {
      let debounce = _.debounce(
        () =>
          this.$store.dispatch('fetchDatafossil', {
            page: this.currentPage,
            filter: this.brands,
            gender: ''
          }),
        500
      );
      debounce();
    },
    addToCart: function(item) {
      this.$store
        .dispatch('addToCart', item)
        .then(() => {
          this.$notify({
            group: 'cart',
            title: 'Product',
            type: 'success',
            text: 'successfuly added to cart!'
          });
        })
        .catch(error => console.log(error));
    },
    ...mapActions(['lastProductfossil','ProductDetail'])
  }
};
</script>

<style scoped>
.product-card img {
  border-radius: 5px;
}
.bg {
  background-image: url('/static/img/5.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 70vh;
  margin-bottom: 10px;
}
.mr-top-30 {
  margin-top: 30px;
}
.mr-top-40 {
  margin-top: 40px;
}
/*.product-card:focus .product-card-buttons,*/
.product-card:hover .product-card-buttons,
.product-card:active .product-card-buttons {
  opacity: 1;
}

.el-slider__button {
  border-color: #8d8b9c !important;
}
.el-slider__bar {
  background-color: #8d8b9c;
}
/*@media (max-width: 640px) {
  .product-card-buttons {
    opacity: 1;
  }
}*/

/*toggle sidebar*/
.sidebaropen {
  left: -48px;
}

.offcanvasopen {
  left: 0;
}
.womenColor{
  color :darkslategray;
}
</style>




// WEBPACK FOOTER //
// src/components/bourdimafossil.vue